import React, { useState } from 'react';
import Header from './Header';
 

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    company: '',
    serviceInterest: 'Microsoft Cloud Solutions',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Connect to your backend API or email handler here
    setSubmitted(true);
  };

  // Inline styles matching the Lidlbritain theme
  const styles = {
    pageWrapper: {
      backgroundColor: '#0b0f19',
      color: '#ffffff',
      minHeight: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      paddingTop: '100px',
    },
    gradientCyanText: {
      background: 'linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 'bold',
    },
    gradientOrangeText: {
      background: 'linear-gradient(135deg, #ff9900 0%, #ff5500 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 'bold',
    },
    glassCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '16px',
      padding: '32px',
    },
    infoCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.03)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      borderRadius: '12px',
      padding: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      marginBottom: '16px',
    },
    iconCircle: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      backgroundColor: 'rgba(0, 242, 254, 0.1)',
      border: '1px solid rgba(0, 242, 254, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#00f2fe',
      fontSize: '1.25rem',
      flexShrink: 0,
    },
    inputField: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      color: '#ffffff',
      borderRadius: '8px',
      padding: '12px 16px',
      fontSize: '0.95rem',
      width: '100%',
    },
    submitBtn: {
      background: 'linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)',
      color: '#000000',
      fontWeight: 'bold',
      padding: '14px 36px',
      borderRadius: '50px',
      border: 'none',
      width: '100%',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'opacity 0.2s ease',
    },
    successBox: {
      backgroundColor: 'rgba(0, 242, 254, 0.1)',
      border: '1px solid #00f2fe',
      borderRadius: '12px',
      padding: '24px',
      textAlign: 'center',
      color: '#ffffff',
    },
  };

  return (
    <div style={styles.pageWrapper}>
      <Header />

      <div className="container py-5">
        {/* HERO HEADER */}
        <div className="text-center mb-5">
          <span
            className="badge rounded-pill px-3 py-2 mb-2"
            style={{
              border: '1px solid #00f2fe',
              color: '#00f2fe',
              backgroundColor: 'rgba(0, 242, 254, 0.1)',
            }}
          >
            Get In Touch
          </span>
          <h1 className="display-4 fw-bold">
            Let's Engineer Your <span style={styles.gradientCyanText}>Digital Future</span>
          </h1>
          <p className="lead text-light opacity-75 mx-auto" style={{ maxWidth: '650px' }}>
            Have a project in mind or need assistance with cloud migration, AI solutions, or digital transformation? Our engineering team is here to help.
          </p>
        </div>

        <div className="row g-4 align-items-start my-4">
          {/* COLUMN 1: CONTACT INFO & DETAILS */}
          <div className="col-12 col-lg-5">
            <h3 className="fw-bold mb-4">Contact Information</h3>

            <div style={styles.infoCard}>
              <div style={styles.iconCircle}>
                <i className="fa-solid fa-envelope"></i>
              </div>
              <div>
                <h6 className="fw-bold mb-1 text-white">Email Us</h6>
                <p className="mb-0 text-light opacity-75 small">contact@lidlbritain.com</p>
                <p className="mb-0 text-light opacity-75 small">support@lidlbritain.com</p>
              </div>
            </div>

            <div style={styles.infoCard}>
              <div style={styles.iconCircle}>
                <i className="fa-solid fa-phone"></i>
              </div>
              <div>
                <h6 className="fw-bold mb-1 text-white">Call Us</h6>
                <p className="mb-0 text-light opacity-75 small">+44 (0) 20 7946 0921</p>
                <p className="mb-0 text-light opacity-75 small">Mon – Fri: 9:00 AM – 6:00 PM GMT</p>
              </div>
            </div>

            <div style={styles.infoCard}>
              <div style={styles.iconCircle}>
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <div>
                <h6 className="fw-bold mb-1 text-white">Global Headquarters</h6>
                <p className="mb-0 text-light opacity-75 small">Lidlbritain Technology Ltd.</p>
                <p className="mb-0 text-light opacity-75 small">100 Bishopsgate, London, EC2N 4AG, UK</p>
              </div>
            </div>

            {/* QUICK HIGHLIGHT */}
            <div
              className="mt-4 p-4 rounded-4"
              style={{
                backgroundColor: 'rgba(255, 153, 0, 0.05)',
                border: '1px solid rgba(255, 153, 0, 0.2)',
              }}
            >
              <h6 style={styles.gradientOrangeText} className="fw-bold mb-2">
                <i className="fa-solid fa-shield-halved me-2"></i>Enterprise SLA Guarantee
              </h6>
              <p className="small text-light opacity-75 mb-0">
                All business inquiries receive a response within 24 business hours from a dedicated certified architect.
              </p>
            </div>
          </div>

          {/* COLUMN 2: CONTACT FORM */}
          <div className="col-12 col-lg-7">
            <div style={styles.glassCard}>
              <h3 className="fw-bold mb-2">Send Us a Message</h3>
              <p className="text-light opacity-75 small mb-4">
                Fill out the form below and we will route your inquiry to the relevant engineering practice group.
              </p>

              {submitted ? (
                <div style={styles.successBox}>
                  <i className="fa-solid fa-circle-check fs-1 text-cyan mb-3"></i>
                  <h4 className="fw-bold mb-2">Thank You!</h4>
                  <p className="mb-0 opacity-90">
                    Your message has been received. A Lidlbritain technology representative will contact you shortly.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label text-light small fw-medium">Full Name *</label>
                      <input
                        type="text"
                        name="fullName"
                        required
                        value={formData.fullName}
                        onChange={handleChange}
                        placeholder="John Doe"
                        style={styles.inputField}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label text-light small fw-medium">Work Email *</label>
                      <input
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="john@company.com"
                        style={styles.inputField}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label text-light small fw-medium">Company Name</label>
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        placeholder="Enterprise Corp"
                        style={styles.inputField}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label text-light small fw-medium">Area of Interest</label>
                      <select
                        name="serviceInterest"
                        value={formData.serviceInterest}
                        onChange={handleChange}
                        style={{ ...styles.inputField, color: '#ffffff', backgroundColor: '#111726' }}
                      >
                        <option value="Microsoft Cloud Solutions">Microsoft Cloud Solutions</option>
                        <option value="AWS Cloud Solutions">AWS Cloud Solutions</option>
                        <option value="Digital Transformation & AI">Digital Transformation & AI</option>
                        <option value="Smart Manufacturing (IIoT)">Smart Manufacturing (IIoT)</option>
                        <option value="Healthcare & Biotech Systems">Healthcare & Biotech Systems</option>
                        <option value="Automotive & Mobility">Automotive & Mobility</option>
                        <option value="Media & Entertainment">Media & Entertainment</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="form-label text-light small fw-medium">Project Summary / Message *</label>
                      <textarea
                        name="message"
                        rows="5"
                        required
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Describe your technical requirements or goals..."
                        style={styles.inputField}
                      ></textarea>
                    </div>

                    <div className="col-12 mt-4">
                      <button type="submit" style={styles.submitBtn}>
                        Submit Inquiry &rarr;
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default ContactUs;